<template>
  <div
    v-if="visible"
    class="hg-dialog-wrapper">
    <div class="hg-dialog">
      <div class="dialog-header">
        <img
          src="../assets/close.png"
          class="dialog-header-right"
          @click="hideDialog" />
      </div>
      <div class="dialog-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '提示'
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  methods: {
    hideDialog () {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .hg-dialog-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background: rgba(0, 0, 0, .5);
    filter: progid:DXImageTransform.Microsoft.gradient(startcolorstr=#7f000000, endcolorstr=#7f000000);
    &:after {
      content: '';
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }
    .hg-dialog {
      min-width: 600px;
      display: inline-block;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 10px;
      .dialog-header {
        padding: 20px 16px 0px 0px;
        overflow: hidden;
        .dialog-header-right {
          float: right;
          width: 15px;
          height: 15px;
          cursor: pointer;
        }
      }
      .dialog-content {
        padding: 5px 20px 30px;
      }
    }
  }
</style>
